import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

// Redux
import { NgRedux } from '@angular-redux/store';
import { IAppState } from '../../core/store/store';

// Core
import { ErrorMessage } from '../../core/model/error-message';
import { IBoolResult, BoolResult } from '../../core/interfaces/bool-result';
import { IObjectResult } from '../../core/interfaces/object-result';

// Config
import { appConfig } from '../../config/app-config';

// Own feature
import { User } from '../model/user';
import { userConfig } from '../../user/config/user.config';
import { UserDatahubService } from '../../user/service/user-datahub.service';
import {
   userChangeCurrent, backendVersion, userRoles
} from '../store/actions';

@Injectable()
export class UserService {

   constructor(
      private _router: Router,
      private _store: NgRedux<IAppState>,
      private _dataHubService: UserDatahubService
   ) { }

   // --------------------------------------------------------------------------------------------
   // -- auth ------------------------------------------------------------------------------------
   // --------------------------------------------------------------------------------------------

   /**
    * isUserSignedIn
    * @returns boolean True is there is an user signed in.
    */
   public isUserSignedIn(): boolean {
      const regular = !!this._store.getState().userState.currentUser &&
         this._store.getState().userState.currentUser.isLoggedIn();
      return regular;
   }

   // --------------------------------------------------------------------------------------------
   // -- sign in functions -----------------------------------------------------------------------
   // --------------------------------------------------------------------------------------------

   /**
    * signIn_email
    * @param account Account of user to sign in.
    * @param password Passwort of user to sign in.
    * @returns Promise<IBoolResult>
    */
   public signIn_email(
      account: string,
      password: string
   ): Promise<IBoolResult> {
      if (userConfig.debugMode) { console.log('[UserService]:signIn_email(called)'); }

      const prom = new Promise<IBoolResult>((resolve, reject) => {

         // sync check
         if (account.trim().length === 0 || password.trim().length === 0) {
            reject(new ErrorMessage('Parameter not valid', '[UserService] Passed user not valid'));
            return;
         }

         // -->>ASY0 - request for signin
         const result: User[] = [];
         this._dataHubService.signIn(
            account,
            password,
            result,
            userConfig.debugMode       // debugMode
         )
         .then((boolResASY0: IBoolResult) => {

            // signin rejected
            if (!boolResASY0.result) {
               resolve(boolResASY0);
               return;
            }

            // to store
            this._store.dispatch(userChangeCurrent(result[0]));
            // <<--
            resolve(BoolResult.createBoolResult_true());
         })
         .catch((err: ErrorMessage) => {
            // reset
            this._store.dispatch(userChangeCurrent(null));
            // <<--
            reject(err);
         });
      });
      return prom;
   }

   // --------------------------------------------------------------------------------------------
   // -- sign out functions ----------------------------------------------------------------------
   // --------------------------------------------------------------------------------------------

   /**
    * signOut
    * @returns Promise<IBoolResult>
    */
   public signOut(
   ): Promise<IBoolResult> {

      if (userConfig.debugMode) { console.log('[UserService]:signOut(called)'); }

      const prom = new Promise<IBoolResult>((resolve, reject) => {

         // sync check
         if (!this._store.getState().userState.currentUser) {
            reject(new ErrorMessage('Store data not as expected', '[UserService] Miss User object'));
            return;
         }

         // -->>ASY0 - request user
         this._dataHubService.signOut(
            this._store.getState().userState.currentUser,
            userConfig.debugMode    // debugMode
         )
         .then((userResASY0: IBoolResult) => {

            // to store
            this._store.dispatch(userChangeCurrent(null));
            // <<--
            resolve(BoolResult.createBoolResult_true());
         })
         .catch((err: ErrorMessage) => {
            // reset
            this._store.dispatch(userChangeCurrent(null));
            // <<--
            reject(err);
         });
      });
      return prom;
   }

   // --------------------------------------------------------------------------------------------
   // -- Load Backend Version
   // --------------------------------------------------------------------------------------------
   public loadBackendVersion(
   ): Promise<IBoolResult> {

      // async
      const prom = new Promise<IBoolResult>((resolve, reject) => {

         // -->> ASY1
         this._dataHubService.loadBackendVersion()
         .then( (fs: any) => {

            // error respond
            if ( typeof fs === 'string') {
               // store
               this._store.dispatch(backendVersion(fs));
            } else if ( typeof fs === 'number') {
               // store
               this._store.dispatch(backendVersion((fs as number).toString()));
            } else {
               // store
               this._store.dispatch(backendVersion('Unbekannt'));
            }

            resolve(BoolResult.createBoolResult_true());
         })
         .catch( err => {
            // Fehler beim Laden des BackendVersionString ignorieren
            this._store.dispatch(backendVersion('Unbekannt'));
            resolve(BoolResult.createBoolResult_false('Unknown backend version'));
         });
      });
      return prom;
   }

    public getUserRoles(
    ): Promise<IBoolResult> {
        // async
        const prom = new Promise<IBoolResult>((resolve, reject) => {
            // -->> ASY1
            this._dataHubService.getUserRoles()
                .then((fs: any) => {
                    // store
                    this._store.dispatch(userRoles(fs));
                    resolve(BoolResult.createBoolResult_true());
                })
                .catch(err => {
                    // Fehler beim Laden des BackendVersionString ignorieren
                    this._store.dispatch(userRoles([]));
                    resolve(BoolResult.createBoolResult_false('Unknown backend version'));
                });
        });
        return prom;
    }

    public changePassword(newPassword: string) {
        const prom = new Promise<IBoolResult>((resolve, reject) => {
            // -->> ASY1
            this._dataHubService.changePassword(
                newPassword
            )
                .then((fs: any) => {
                    this.signOut().then(() => {
                    // store
                        resolve(BoolResult.createBoolResult_true());
                    });                
                })
                .catch(err => {
                    resolve(BoolResult.createBoolResult_false('Password Fehler'));
                });
        });
        return prom;
    }
}



// WEBPACK FOOTER //
// /builds/cp/frap/t3/planer/src/app/user/service/user.service.ts